__turbopack_context__.v({
  "Container": "g9k2oq_Container",
  "FullWidth": "g9k2oq_FullWidth",
  "Root": "g9k2oq_Root",
  "Slide": "g9k2oq_Slide",
  "Testimonial": "g9k2oq_Testimonial",
});
